import moment from "moment";
import React, { useState, useEffect } from "react";
import { APPLICABLE_ROLE, CONSULTATIONTYPE } from "../Constant";
import { getProcedureForConsultationFilter } from "../DashboardAppointmentsViewApiHandler";
import { USER_ROLE } from "../../../Util/constants";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    //add listener to window to observe changes
    window.addEventListener("resize", handleResize);
    //Initial Call
    handleResize();
    // removing listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

export const addQuery = (history, location, key, value) => {
  let pathname = location.pathname;
  let searchParams = new URLSearchParams(location.search);
  key.forEach((param, index) => {
    // HOTFIX FOR: 16116 ==>
    if (key[index] === "consultation_type") {
      if (value[index] === "undefined") {
        searchParams.set(key[index], "in-clinic");
        return;
      }
    }
    // <==
    searchParams.set(key[index], value[index]);
  });
  history.push({
    pathname: pathname,
    search: searchParams.toString(),
  });
  addDashboardFilterLocalStorage(searchParams.toString());
};

function removeParam(key, params) {
  let param,
    params_arr = [],
    queryString = params.indexOf("?") !== -1 ? params.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    let arr = params_arr.filter((pa) => {
      param = pa.split("=")[0];
      return !key.includes(param);
    });
    params = arr ? arr.join("&") : "";
  }
  return params;
}

export const removeQuery = (history, location, key) => {
  let pathname = location.pathname;
  let params = removeParam(key, location.search);
  history.push({
    pathname: pathname,
    search: params.toString(),
  });
  C2CConsole.log(params.toString(), "removed Query");
  addDashboardFilterLocalStorage(params.toString());
};

export const checkNullValue = (value) => {
  if (value) {
    return value;
  } else {
    return "";
  }
};

export const removeDashboardFilterFromLocalStorage = () => {
  localStorage.removeItem("dashboardFilters");
};

export const addDashboardFilterLocalStorage = (data) => {
  localStorage.setItem("dashboardFilters", data);
};

export const getDashboardFilterFromLocalStorage = () => {
  return localStorage.getItem("dashboardFilters");
};

export const debounce = (func, delay) => {
  let debounceHandler;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceHandler);
    debounceHandler = setTimeout(() => func.apply(context, args), delay);
  };
};

export const getProcedureAPIPayload = ({
  clinic_id,
  doctor_name_filter,
  doctor_selected,
  user_id,
  doctorRole,
  user_type,
  token,
}) => {
  let payload = {
    clinic_id: clinic_id,
  };
  if (
    doctorRole === USER_ROLE.DOCTOR_ADMIN ||
    doctorRole === USER_ROLE.RESOURCE_ADMIN ||
    user_type === APPLICABLE_ROLE.STAFF
  ) {
    payload["doctor_ids"] = doctor_name_filter
      ? [doctor_name_filter]
      : doctor_selected;
  } else {
    payload["doctor_ids"] = [user_id];
  }
  return getProcedureForConsultationFilter(payload, token);
};

export const getConsultationTypeDetail = (appnt) => {
  let appointmentTypeText =
    appnt.appointment_type === CONSULTATIONTYPE.INCLINIC
      ? CONSULTATIONTYPE.INCLINIC
      : CONSULTATIONTYPE.TELECONSULT;
  switch (appnt.consultation_type) {
    case CONSULTATIONTYPE.REGULAR.toLowerCase():
      return (
        <span>{appointmentTypeText + " " + CONSULTATIONTYPE.REGULAR}</span>
      );
    case CONSULTATIONTYPE.FOLLOWUP:
      return (
        <span>{appointmentTypeText + " " + CONSULTATIONTYPE.FOLLOW_UP}</span>
      );
    case CONSULTATIONTYPE.PROCEDURE:
      return <span>{appnt.procedure_name}</span>;
    case CONSULTATIONTYPE.INSTANT.toLowerCase():
      return <span>{CONSULTATIONTYPE.INSTANT}</span>;
    default:
      return "";
  }
};

const getHrs = (hrs) => {
  let hours = "";
  if (hrs >= 1) {
    hours = hrs;
    hours += hrs > 1 ? " Hrs " : " Hr ";
  }
  return hours;
};

const getMins = (mins) => {
  let minutes = "";
  if (mins >= 0) {
    minutes = mins;
    minutes += mins > 1 || mins === 0 ? " Mins" : " Min";
  }
  return minutes;
};

export const getWaitingTime = (captured_time, appnt) => {
  if (captured_time?.consultation_started?.consultation_started_time) {
    let start_time = new Date(
      captured_time?.consultation_started?.consultation_started_time
    );
    let check_in_time = new Date(
      Math.max(
        new Date(captured_time?.checked_in?.checked_in_time),
        new Date(appnt.appointment_date_and_time)
      )
    );
    let diff = start_time - check_in_time;
    let mins = Math.floor(diff / 60000);
    let hrs = Math.floor(diff / 60000 / 60);
    mins = mins > 0 ? mins - hrs * 60 : mins;
    hrs = getHrs(hrs);
    mins = getMins(mins);
    let minsVal = mins.toString() !== "0 Mins" ? mins : "";
    let minutes = hrs ? minsVal : mins;

    return hrs || mins ? hrs + minutes : "0 Mins";
  } else if (captured_time?.checked_in?.checked_in_time) {
    let start_time =
      moment(captured_time?.checked_in?.checked_in_time).format(
        "MM DD YYYY"
      ) === moment().format("MM DD YYYY")
        ? new Date()
        : new Date(
            captured_time?.checked_in?.checked_in_time.split(" ")[0] +
              " 11:59:59 PM"
          );
    let check_in_time = new Date(
      Math.max(
        new Date(captured_time?.checked_in?.checked_in_time),
        new Date(appnt.appointment_date_and_time)
      )
    );
    let diff = start_time - check_in_time;
    let mins = Math.floor(diff / 60000);
    let hrs = Math.floor(diff / 60000 / 60);
    mins = mins > 0 ? mins - hrs * 60 : mins;
    hrs = getHrs(hrs);
    mins = getMins(mins);
    let minsVal = mins.toString() !== "0 Mins" ? mins : "";
    let minutes = hrs ? minsVal : mins;

    return hrs || mins ? hrs + minutes : "0 Mins";
  } else {
    return "0 Mins";
  }
};

export const displayListQueueButton = (consultation_type, selected_date) => {
  const currentDate = moment().format("YYYY-MM-DD");
  let display = false;
  if (
    consultation_type?.value === CONSULTATIONTYPE.INCLINIC &&
    currentDate == selected_date
  ) {
    display = true;
  }
  return display;
};

export default useWindowSize;
